import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import './App.css';
import HomePage from "./Home"
import PaEPage from './PaE';
import AboutPage from "./About"
import ContactPage from './Contact';
import BeliefPage from './Beliefs';

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/involvement" element={<PaEPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/beliefs" element={<BeliefPage />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
